import { cn } from "@repo/utils";

export const LOG_TABLE_COLUMNS = [
  { key: "date", label: "Date/Time", width: "auto" },
  { key: "user", label: "User", width: "auto" },
  { key: "from", label: "From", width: "auto" },
  { key: "arrow", label: "", width: "auto" },
  { key: "to", label: "To", width: "auto" },
  { key: "workflow", label: "Workflow", width: "auto" },
] as const;

export const LOG_TABLE_CELL_GAP = "px-2 first:pl-0 last:pr-0";

export const logsCellClass = cn("truncate py-3 text-sm text-gray-700", LOG_TABLE_CELL_GAP);

export const formatLogsDateTime = (dateString: string): string => {
  const date = new Date(`${dateString}Z`);

  const locale = navigator.language;
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const parts = new Intl.DateTimeFormat(locale, {
    timeZone: timeZone,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "";

  return `${get("day")}.${get("month")}.${get("year")}   ${get("hour")}:${get("minute")}`;
};
